import React from "react";
import { Activity, UserPlus, Zap, Hourglass, HelpCircle } from "lucide-react";
import "./LogsSection.css";

// Dicionário de tradução dos tipos de evento
const EVENT_LABELS = {
  new_lead: "Novo Lead",
  payment_approved: "Pagamento Aprovado",
  payment_pending: "Pagamento Pendente",
};

// Ícones lucide-react por tipo de evento
const EVENT_ICONS = {
  new_lead: UserPlus,
  payment_approved: Zap,
  payment_pending: Hourglass,
};

// Cores por tipo de evento
const EVENT_COLORS = {
  new_lead: "#3B82F6",          // azul
  payment_approved: "#22c55e",  // verde
  payment_pending: "#F59E0B",   // laranja
};


const LogsSection = ({ logs = [], loading = false, fmtDate = (d) => d }) => {
  return (
    <div className="ranking-card logs-container">
      <h3><Activity size={16} strokeWidth={2.5} /> Atividades Recentes</h3>
      <div className="logs-scroll">
        {loading ? (
          Array(4)
            .fill(0)
            .map((_, i) => <div key={i} className="log-card log-skeleton" />)
        ) : logs.length > 0 ? (
          logs.map((log, idx) => {
            const label = EVENT_LABELS[log.event_type] || log.event_type;
            const EventIcon = EVENT_ICONS[log.event_type] || HelpCircle;
            const color = EVENT_COLORS[log.event_type] || "#999";
            return (
              <div key={log.id || log.created_at || idx} className="log-card">
                <div className="log-icon" style={{ backgroundColor: color }}>
                  <EventIcon size={18} color="#fff" strokeWidth={2.5} />
                </div>
                <div className="log-info">
                  <div className="log-type">{label}</div>
                  <div className="log-desc">{log.description}</div>
                </div>
                <div className="log-meta">
                  <div className="log-time">{fmtDate(log.created_at, 'time')}h</div>
                  <div className="log-date">{fmtDate(log.created_at, 'date')}</div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="log-card">
            <p>Nenhuma atividade recente encontrada.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogsSection;
